// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_YJYoj","form":"form_iAWqW","horizontal-style":"horizontal-style_SjgJw","ant-form-item":"ant-form-item","reverse":"reverse_e5uqb"};